import script from "./groups.vue?vue&type=script&setup=true&lang=js"
export * from "./groups.vue?vue&type=script&setup=true&lang=js"

import "./groups.vue?vue&type=style&index=0&id=41deaa58&lang=scss&scoped=true"

import exportComponent from "/root/buildarea/v8-production-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41deaa58"]])

export default __exports__